import Pix from './Pix'
import PixKey from './PixKey'
import PixQrCode from './PixQrCode'
import Transfer from './Transfer'
import Bill from './Bill'
import Withdraw from './Withdraw'

/* O endereço da área. Precisa bater com a rota registrada no `App.js`. */
export const BANKING_PATH = '/business/banking'

/*
  As telas de operação do Cutilei Pay, no lugar da aba de movimentação.

  Nos apps cada uma é uma tela da stack. Aqui cada uma tem o seu endereço dentro da área, e é
  isso que faz o voltar do navegador — e o botão lateral do mouse — sair de "Sacar" para o
  saldo, em vez de sair do Cutilei Pay. `path` é o trecho depois de `BANKING_PATH`.

  `parent` é para onde volta o botão da própria tela. Existe por causa da área Pix: de "copia
  e cola" se volta para a lista de formas de pagar, e não para o saldo.
*/
const OPERATIONS = {
  pix: { path: 'pix', parent: null, Component: Pix },
  pix_key: { path: 'pix-key', parent: 'pix', Component: PixKey },
  pix_qr_code: { path: 'pix-qr-code', parent: 'pix', Component: PixQrCode },
  transfer: { path: 'transfer', parent: null, Component: Transfer },
  bill: { path: 'bill', parent: null, Component: Bill },
  withdraw: { path: 'withdraw', parent: null, Component: Withdraw }
}

/* O endereço de uma operação, ou o da área quando não há operação. */
export const operationPath = operation => (
  operation ? `${BANKING_PATH}/${OPERATIONS[operation].path}` : BANKING_PATH
)

/* A operação de um trecho de endereço, ou `null` para o que não é operação. */
export const operationFromPath = path => (
  Object.keys (OPERATIONS).find (key => OPERATIONS[key].path === path) ?? null
)

export default OPERATIONS
